import { CRUDAction, IEntityFetchCollectionSuccess, IEntityFetchSuccess, RequestAction } from "store/entities/actions";

import { LICENSE, LicenseAction } from "./actions";
import { ILicense } from "./interfaces";

const initialState = null;

// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'ILicense'.
export const licenseReducer = (state: ILicense = initialState, action: LicenseAction): ILicense => {
  switch (action.type) {
    case LICENSE[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'License... Remove this comment to see the full error message
      const { values } = action.payload as IEntityFetchCollectionSuccess<ILicense>;
      return { ...values[0] };
    }

    case LICENSE[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case LICENSE[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'License... Remove this comment to see the full error message
      const { value } = action.payload as IEntityFetchSuccess<ILicense>;
      const { livechatProperties } = state;

      return { ...value, livechatProperties };
    }

    case LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.REQUEST]: {
      const { livechatProperties } = state;
      if (!livechatProperties || livechatProperties.status === "error") {
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Record<stri... Remove this comment to see the full error message
        return { ...state, livechatProperties: { status: "loading", data: null } };
      }
      return state;
    }

    case LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'License... Remove this comment to see the full error message
      return { ...state, livechatProperties: { status: "success", data: action.payload } };
    }

    case LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.FAILURE]: {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Record<stri... Remove this comment to see the full error message
      return { ...state, livechatProperties: { status: "error", data: null } };
    }

    default:
      return state;
  }
};
